import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PublicLayout, { H1, Lead } from "../../components/PublicLayout";
import { SITE } from "../../content/site";
import { routePath } from "../../lib/routes";
import { track, EVENTS } from "../../lib/analytics";

export default function Technology({ lang }) {
  const c = (SITE[lang].technology2 || SITE.en.technology2);
  const nav = SITE[lang].nav.technology ? SITE[lang].nav : SITE.en.nav;
  const alt = (SITE[lang].events || SITE.en.events).alt;
  useEffect(() => { window.scrollTo(0, 0); track(EVENTS.PAGE_VIEW, { page: "technology", lang }); }, [lang]);

  return (
    <PublicLayout pageKey="technology" lang={lang}
      crumbs={[{ name: nav.technology, path: routePath("technology", lang) }]}>
      <div data-testid="technology-page">
        <section className="mx-auto max-w-[1200px] px-6 pb-14 pt-14 md:px-8 md:pt-20">
          <p className="overline mb-4 text-[#9a9a9a]">{c.overline}</p>
          <H1>{c.h1}</H1>
          <Lead>{c.sub}</Lead>
        </section>
        <section className="relative h-[46vh] overflow-hidden md:h-[62vh]">
          <img src="/events/usa.jpg" alt={alt.usa} loading="lazy" width="1920" height="1280"
            className="absolute inset-0 h-full w-full object-cover" />
        </section>
        <section className="mx-auto max-w-[1200px] px-6 py-20 md:px-8 md:py-28">
          {c.sections.map((s, i) => (
            <div key={s.t} data-testid={`technology-section-${i}`}
              className="grid gap-4 border-t border-black/8 py-10 md:grid-cols-[320px_1fr] md:gap-14 md:py-12">
              <h2 className="font-display text-xl font-normal tracking-tight text-[#050505] md:text-2xl">{s.t}</h2>
              <p className="max-w-2xl text-base font-light leading-relaxed text-[#4a4a4a] md:text-lg">{s.d}</p>
            </div>
          ))}
          <Link to={routePath("work", lang)} data-testid="technology-cta"
            onClick={() => track(EVENTS.CTA_CLICK, { cta: "technology_work" })}
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#050505] px-8 py-3.5 text-sm font-medium text-white transition-opacity hover:opacity-85">
            {c.cta} <ArrowRight size={16} />
          </Link>
        </section>
      </div>
    </PublicLayout>
  );
}
